"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Permission = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.Permission = {
  name: 'Permission',
  label: 'Permission',
  type: 'taxonomy',
  autoRoutes: ['list', 'create', 'update'],
  table: {
    fieldNames: ["grantedPerson", "permissionTypes"]
  },
  form: {
    modal: {
      fill: true
    },
    bufferAtEnd: 250,
    fields: __assign(__assign({}, create_entity_1.entityCoreFormFields), {
      organisation: {
        type: 'linked',
        variant: 'forPerson',
        required: true,
        entityTypeName: 'Organisation'
      },
      location: {
        type: 'linked',
        variant: 'forPerson',
        required: true,
        entityTypeName: 'Location'
      },
      grantedPerson: {
        type: 'grantedPerson',
        description: 'Which {{PERSON}} should be granted this {{PERMISSION}}?'
      },
      permissionTypes: {
        type: 'linkedMultiple',
        maxMenuHeight: 300,
        required: true,
        canCreate: function () {
          return false;
        },
        entityTypeName: 'PermissionType'
      }
    })
  },
  update: {
    queryFields: "\n      id name slug permissionTypes { id name slug } grantedPerson { id name slug organisation { id name } photo { id url } location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } } }\n    "
  }
};